<template>
  <!-- 全屏 -->
  <div class="vw100 vh100 column a-center o-h">
    <!-- 收缩容器 -->
    <div id="fullScreenContainer" ref="fullScreenContainer" class="relative o-h" style="flex-shrink: 0;">
      <!-- 导航栏 -->
      <my-nav :current="current" @onHandleShow="handleShow"></my-nav>
      <!-- 内容 -->
      <div ref="content" class="main w-per100 flex1 bg_fff c_333 relative" style="overflow-x: hidden;overflow-y: auto;">
        <slot v-if="ready" />
      </div>
    </div>
  </div>
  
</template>

<script>
const DESIGN_WIDTH = 1920
// 设计稿中导航栏高度（未缩放坐标）
const NAV_HEIGHT_DESIGN = 60
export default {
  name: 'FullScreenContainer',
  data() {
    return {
      ready: false,
      current: 0,
      screenHeight: 1080,
      scale: 1,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initContainer()
      this.setAppScale()
      this.ready = true
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    $route: {
      handler(newVal) {
        this.getCurrent()
      },
      immediate: true,
    },
  },
  methods: {
    getCurrent(){
      let path = this.$route.path
      if(path === '/'){
        this.current = 0
      }else if(path === '/service'){
        this.current = 1
      }else if(path === '/activity'){
        this.current = 2
      }else if(path === '/overall'){
        this.current = 3
      }else if(path === '/aboutus'){
        this.current = 4
      }
    },
    scrollContainerTo(top = 0) {
      const contentEl = this.$refs.content
      if (!contentEl) return
      contentEl.scrollTo({
        top,
        left: 0,
        behavior: 'smooth',
      })
    },
    // 导航栏切换
    handleShow(index,id) {
      // console.log(index)
      let old = this.current;
      this.current = index;
      // console.log('old',old,'new',index)
      if(old === index){
        this.scrollContainerTo(0)
        return ;
      }
      if (index === 0) {
        this.$router.push({ path: "/" })
        this.scrollContainerTo(0)
      }
      if (index === 1) {
        this.$router.push({ path: "/service" })
        this.scrollContainerTo(0)
      }
      if (index === 2) {
        this.$router.push({ path: "/activity" })
        this.scrollContainerTo(0)
      }
      if (index === 3) {
        this.$router.push({ path: "/overall" })
        this.scrollContainerTo(0)
      }
      if (index === 4) {
        this.$router.push({ path: "/aboutus" })
        this.scrollContainerTo(0)
      }
      if(id){
        setTimeout(()=>{
          var el = document.getElementById(id)
          this.$nextTick(() => {
            const contentEl = this.$refs.content
            if (!contentEl || !el) return
            contentEl.scrollTo({
              behavior: "smooth",
              top: el.offsetTop + -88,
              left: 0,
            })
          })
        },100)
      }else{
        return
      }
    },
    // 回顶部
    handelUpdate() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    },
    initContainer() {
      const el = this.$refs.fullScreenContainer
      if (!el) return
      el.style.width = `${DESIGN_WIDTH}px`
    },
    setAppScale() {
      const el = this.$refs.fullScreenContainer
      const contentEl = this.$refs.content
      if (!el || !contentEl) return
      const currentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0
      const currentHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
      console.log('wh',currentWidth,currentHeight)
      this.screenHeight = currentHeight
      if (!currentWidth || !currentHeight) return

      const scale = currentWidth / DESIGN_WIDTH
      this.scale = scale
      // console.log('scale',scale)

      // 由“窗口宽高比 = 设计宽 : 容器设计高”推算容器设计高度
      const containerDesignHeight = currentHeight / scale
      // console.log('hhh',containerDesignHeight)
      el.style.height = `${containerDesignHeight}px`

      // 内容设计高度 = 容器设计高度 - 导航栏设计高度
      const contentDesignHeight = containerDesignHeight - NAV_HEIGHT_DESIGN
      contentEl.style.height = `${contentDesignHeight}px`

      // 等比缩放，避免内容被拉伸
      el.style.transform = `scale(${scale}, ${scale})`
    },
    onResize() {
      this.initContainer()
      this.setAppScale()
    },
  },
}
</script>

<style lang="scss" scoped>
#fullScreenContainer{
  transform-origin: top center;
}
</style>
